module.exports = __webpack_public_path__ + "static/EnmTX_BosGustav_L_A_cl-e9868d1ad76d37cd17841b46cc4a8c95.gif";